<template>
  <div
    class="navbar-container d-flex content align-items-center"
    :class="envLabel ? 'env-banner' : ''"
  >
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
      <span
        v-if="envLabel"
        class="ml-1"
        style="font-weight: bold; text-transform: uppercase; font-size: 18px"
        >{{ envLabel }}</span
      >
      <span class="ml-1" style="font-size: 12px" v-else>
        v. 9.0.0
      </span>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- Indicador do nó ativo -->
      <b-nav-item
        v-if="selectedNode"
        class="d-none d-md-flex align-items-center mr-1"
        title="Trocar nó"
        @click="$router.push('/select-node')"
        style="cursor: pointer"
      >
        <feather-icon
          icon="GitBranchIcon"
          size="16"
          class="mr-50 text-primary"
        />
        <span class="text-primary font-weight-bold" style="font-size: 0.85rem">
          {{ selectedNode.name }}
        </span>
      </b-nav-item>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none flex-column user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user.name }}
            </p>
            <span
              v-if="user.professional_name"
              class="text-primary"
              style="font-size: 0.75rem; line-height: 1"
            >
              {{ user.professional_name }}
            </span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="user.photo"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <router-link :to="'/profile'">
            <span>Meu Perfil</span>
          </router-link>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MailIcon" class="mr-50" />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import env from "../../config/env";

const ENV_LABELS = {
  dev: "DEV",
  homolog: "Ambiente de Homologação",
};

export default {
  data() {
    return {
      authenticated: false,
      disabled: true,
      user: {},
    };
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItem,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  computed: {
    selectedNode() {
      return this.$store.state.selected_node;
    },
    envLabel() {
      return ENV_LABELS[env.mode] || null;
    },
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      axios
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          self.$router.push({ path: "/login" });

          setTimeout(function () {
            location.reload();
          }, 500);
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
  },
  mounted() {
    const self = this;
    setTimeout(function () {
      self.user = self.$store.state.user;
      console.log(self.user);
      if (self.user.password_expired == 1) {
        $("#modalChangePassword").modal({
          backdrop: "static",
          keyboard: false, // to prevent closing with Esc button (if you want this too)
        });
      }
    }, 500);
  },
};
</script>
<style scoped>
.env-banner {
  background-color: rgb(236, 92, 92);
  color: white !important;
  border-radius: 7px;
}
</style>
